<template>
  <div role="main" class="detalle-main-wrap">
    <div class="content-header">
      <div class="container-fluid detalle-wide-container">
      <div class="detalle-head">
        <div class="detalle-head-top">
          <div>
            <div class="detalle-ref-line">
              <span class="detalle-ref-link" @click="goToHome">MIS ÓRDENES</span>
              <span class="detalle-ref-sep">›</span>
              <span class="detalle-ref-link" @click="goToServicios">{{ cotizacionReferencia }}</span>
              <span class="detalle-ref-sep">›</span>
              <span class="detalle-ref-strong">{{ clienteServicioReferencia }}</span>
            </div>
            <h1 class="detalle-title">Detalle de servicio</h1>
          </div>
          <div class="detalle-profile-chip" :title="detalle?.Servicio?.cliente_nombre || 'Cliente'">
            <div class="detalle-profile-avatar">
              <span
                v-if="clienteLogoUrl && !logoLoaded"
                class="detalle-profile-placeholder"
                aria-hidden="true"
              ></span>
              <img
                v-if="clienteLogoUrl"
                :src="clienteLogoUrl"
                alt="Logo del cliente"
                :class="[
                  'detalle-profile-image',
                  'detalle-profile-image--cliente',
                  { 'detalle-profile-image--visible': logoLoaded }
                ]"
                @load="onLogoLoad"
                @error="onLogoError"
              />
              <span v-else>{{ clienteIniciales }}</span>
            </div>
          </div>
        </div>
        <div class="tramite-progress-wrap">
          <div class="tramite-steps">
            <div
              v-for="(etapa, index) in etapasTramite"
              :key="etapa.id"
              class="tramite-step"
              :class="{
                'tramite-step--done': index < etapaActualIndex,
                'tramite-step--active': index === faseVistaIndex,
                'tramite-step--actual': index === etapaActualIndex,
                'tramite-step--locked': !canSelectFase(index)
              }"
              @click="setFaseVista(index)"
            >
              <span class="tramite-step-phase">Fase {{ index + 1 }}</span>
              <div class="tramite-step-top">
                <span class="tramite-step-badge">{{ index + 1 }}</span>
                <i :class="['tramite-step-icon', etapa.icon]"></i>
                <span class="tramite-step-label">{{ etapa.label }}</span>
              </div>
              <span class="tramite-step-state">
                {{
                  index === etapaActualIndex && index === faseVistaIndex
                    ? "Actual"
                    : index === etapaActualIndex
                    ? "Actual"
                    : index < etapaActualIndex
                    ? "Completada"
                    : "Pendiente"
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="content" style="padding: 10px;">
      <div class="container-fluid detalle-wide-container">
      <div class="card service-summary-card">
        <div class="card-body p-3 p-md-4">
          <div class="row align-items-start">
            <div class="col-12 col-lg-8 mb-2 mb-lg-0 text-left">
              <h5 class="mb-0 font-weight-bold text-dark">
                {{ detalle?.Servicio?.cliente_nombre || "Cliente" }}
              </h5>
            </div>
            <div class="col-12 col-lg-4 text-left text-lg-right">
              <div class="d-flex flex-wrap justify-content-start justify-content-lg-end" style="gap: 8px">
                <span class="service-pill service-pill--folio">
                  Folio: {{ detalle?.Servicio?.Cotizacione?.folio || "-" }}
                </span>
                <span class="service-pill service-pill--date">
                  <i class="fas fa-calendar-day mr-1"></i>
                  Creación: {{ fechaCreacion }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="body-card mb-3">
        <div class="d-flex flex-column flex-md-row w-100">
        <section class="nom-card datos-card flex-fill">
          <div class="d-flex justify-content-between align-items-center">
            <h5 style="margin: 0">
              {{
                faseVistaIndex === 1
                  ? "Revisión de campo"
                  : faseVistaIndex === 2
                  ? "Descarga de portafolio"
                  : "Subir documentos"
              }}
            </h5>
            <button
              v-if="notas === false"
              class="btn-notas"
              v-on:click="notas = !notas"
            >
              Mostrar historial
            </button>
          </div>
          <hr />
          <div v-if="faseVistaIndex === 2" class="fase3-hero">
            <p class="fase3-hero__eyebrow">Fase final</p>
            <h3 class="fase3-hero__title">Tu portafolio está listo para descargar</h3>
          </div>
          <div class="row">
            <template v-if="faseVistaIndex === 2">
              <div class="col-12" v-if="entregasVisibles.length === 0">
                <div class="alert alert-light border text-left mb-3">
                  Aún no hay entregas disponibles para descarga.
                </div>
              </div>
              <div
                v-for="entrega in entregasVisibles"
                :key="`entrega-${entrega.id}`"
                class="col-12 mb-3"
              >
                <div class="fase3-entrega-card text-left">
                  <div class="fase3-entrega-head">
                    <div class="fase3-entrega-title-wrap">
                      <span class="fase3-entrega-icon">
                        <i class="fas fa-briefcase"></i>
                      </span>
                      <h6 class="fase3-entrega-title">{{ entrega.nombre }}</h6>
                    </div>
                    <span class="fase3-entrega-badge">
                      {{ (entrega.archivos_entrega || []).length }} archivo(s)
                    </span>
                  </div>
                  <div
                    v-if="entrega.archivos_entrega && entrega.archivos_entrega.length > 0"
                    class="fase3-files-list"
                  >
                    <div
                      v-for="archivo in entrega.archivos_entrega"
                      :key="`entrega-archivo-${archivo.id}`"
                      class="fase3-file-item"
                    >
                      <div class="fase3-file-meta">
                        <span class="fase3-file-icon">
                          <i class="fas fa-file-alt"></i>
                        </span>
                        <span class="fase3-file-name" :title="archivo.nombre">{{ archivo.nombre }}</span>
                      </div>
                      <div class="fase3-file-actions">
                        <button
                          class="btn fase3-file-btn mr-2"
                          :disabled="isFileDownloading(archivo.id || archivo.url)"
                          @click="descargarArchivo(archivo.url, archivo.id || archivo.url)"
                        >
                          <i
                            :class="[
                              'fas mr-1',
                              isFileDownloading(archivo.id || archivo.url)
                                ? 'fa-circle-notch fa-spin'
                                : 'fa-download',
                            ]"
                          ></i>
                          <span v-if="isFileDownloading(archivo.id || archivo.url)">
                            Descargando {{ getFileDownloadProgress(archivo.id || archivo.url) }}%
                          </span>
                          <span v-else>Descargar</span>
                        </button>
                        <button
                          class="btn fase3-file-btn fase3-file-btn--preview"
                          @click="vistaPrevia(archivo.url)"
                        >
                          <i class="fas fa-eye mr-1"></i>
                          Vista previa
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else class="fase3-empty text-muted">
                    Esta entrega aún no tiene archivos.
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
            <div
              v-if="faseVistaIndex === 1 && documentosVisibles.length === 0"
              class="col-12"
            >
              <div class="revision-empty-notice">
                <div class="revision-empty-notice__icon">
                  <i class="fas fa-comments"></i>
                </div>
                <div>
                  <h6 class="revision-empty-notice__title">Sin observaciones por revisar</h6>
                  <p class="revision-empty-notice__text mb-0">
                    Aún no se han generado observaciones de campo para este servicio.
                  </p>
                </div>
              </div>
            </div>
            <template v-for="(doc, index1) in documentosVisibles">
              <div
                class="col-12 col-md-6 col-lg-6 mb-4"
                :key="index1"
                style="margin-bottom: 0.5rem !important"
              >
                <div
                  class="card-document"
                  :class="{
                    pendiente: doc.estatus === 0 || doc.estatus == false,
                    'en-revision': doc.estatus === 1 || doc.estatus == true,
                    aceptado: doc.estatus === 2,
                    rechazado: doc.estatus === 3,
                  }"
                >
                  <div class="card-document-body">
                    <div style="text-align: left; max-width: 60%">
                      <div class="d-flex align-items-center">
                        <h6 class="m-0" style="overflow-wrap: break-word; max-width: 100%">
                          {{ doc.detalles.nombre }}
                        </h6>
                      </div>
                      <span class="badge" :class="getDocStatusBadgeClass(doc)">
                        {{ getDocStatusText(doc) }}
                      </span>
                      <p
                        v-if="doc.detalles.descripcion"
                        class="card-document-desc"
                      >
                        {{ doc.detalles.descripcion }}
                      </p>
                    </div>

                    <div class="content-buttons">
                      <button
                        class="btn-doc btn-info"
                        v-if="doc.documento_id === 1"
                        @click="irdatos_generales(doc)"
                      >
                        Actualizar datos
                      </button>
                      <button
                        class="btn-doc btn-secondary"
                        v-if="
                          doc.documento_id == 3 ||
                          doc.documento_id == 46 ||
                          doc.documento_id == 47
                        "
                        @click="
                          descargarFormato(doc.documento_id, doc.detalles.nombre)
                        "
                      >
                        Descagar formato
                      </button>
                      <button
                        class="btn-doc btn-inspector-attn"
                        v-if="hasInspectorFiles(doc)"
                        @click="abrirModalInspector(doc)"
                      >
                        Ver anexos
                      </button>
                      <button
                        class="btn-doc btn-primary"
                        v-if="doc.documento_id != 1"
                        @click="abrirModal(doc, index1)"
                      >
                        {{ doc.estatus == 0 ? "Subir archivo" : "Editar archivo" }}
                      </button>
                      <button
                        @click="vistoChat(doc)"
                        :class="[
                          'btn-doc',
                          'position-relative',
                          hasPendingObservaciones(doc) ? 'btn-observaciones-attn' : 'btn-observaciones'
                        ]"
                        data-toggle="modal"
                        :data-target="'#modalNotas' + index1"
                      >
                        Observaciones
                        <span
                          v-if="hasPendingObservaciones(doc)"
                          class="notas-pill"
                        >
                          Nuevo
                        </span>
                        <i class="fa fa-solid fa-comments ml-1"></i>
                        <span
                          v-if="hasPendingObservaciones(doc)"
                          class="notas-indicator"
                        >
                          !
                        </span>
                      </button>
                      <button
                        type="button"
                        class="btn-doc btn-info"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        :title="doc.detalles.descripcion"
                        v-if="doc.documento_id == 62"
                      >
                        Facturar
                      </button>
                    </div>
                  </div>

                  <div v-if="uploadProgress[index1] > 0" class="progress mt-2">
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      :style="{ width: uploadProgress[index1] + '%' }"
                      :aria-valuenow="uploadProgress[index1]"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>

                  <!-- Modal específico para cada documento -->
                  <div
                    class="modal fade"
                    :id="'modalNotas' + index1"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="modalNotasLabel"
                    aria-hidden="true"
                    data-keyboard="false"
                    style="max-height: 95vh"
                  >
                    <div class="modal-dialog" role="document" style="height: 90%; max-height: 60rem">
                      <div class="modal-content" style="height: 100%">
                        <div class="modal-header">
                          <h5 class="modal-title" id="modalNotasLabel">
                            Observaciones en {{ doc.detalles.nombre }}
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body" style="height: 75%">
                          <transition-group
                            :ref="`comentariosContainer-${doc.Servicios_documentos_id}`"
                            name="comentario-arrive"
                            tag="div"
                            class="card-footer card-comments bg-white p-3 rounded chat-thread"
                            style="
                              max-height: 50rem;
                              overflow-y: auto;
                              height: 80%;
                            "
                          >
                            <div
                              v-for="(coment) in doc.Comentarios"
                              :key="coment.id"
                              class="mb-3"
                            >
                              <div
                                class="d-flex"
                                :class="
                                  coment.user == 1
                                    ? 'justify-content-end'
                                    : 'justify-content-start'
                                "
                              >
                                <div
                                  class="d-flex align-items-start"
                                  :class="coment.user == 1 ? 'flex-row-reverse text-right' : ''"
                              >
                                <span
                                  v-if="coment.user != 1"
                                  class="comment-author-icon mr-2 comment-author-icon--empresa"
                                >
                                  <img
                                    :src="logoBaessh"
                                    alt="BAESSH"
                                    class="comment-author-image"
                                  />
                                </span>
                                <div
                                  class="chat-bubble shadow-sm"
                                  :class="
                                    coment.user == 1
                                      ? 'chat-bubble--cliente text-right'
                                      : 'chat-bubble--baessh text-left'
                                  "
                                >
                                  <div class="comment-body-text mb-1">
                                    {{ coment.comentario }}
                                  </div>
                                  <div>
                                    <span class="text-muted small d-block chat-time">
                                      {{ formatDate(coment) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              </div>
                            </div>
                          </transition-group>

                          <div class="card-comment mt-2">
                            <div class="form-group mb-2">
                              <textarea
                                @keydown.enter.prevent="
                                  guardarComentario(doc.Servicios_documentos_id)
                                "
                                cols="30"
                                rows="2"
                                v-model="comentarioByDocumento[doc.Servicios_documentos_id]"
                                class="form-control"
                                placeholder="Escribe aquí..."
                              ></textarea>
                            </div>
                            <div class="d-flex justify-content-end">
                              <button
                                class="btn btn-primary btn-sm"
                                v-on:click="
                                  guardarComentario(doc.Servicios_documentos_id)
                                "
                              >
                                Enviar
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            </template>
          </div>
          <ModalFile
            v-if="mostrarModal"
            :visible="mostrarModal"
            :documento-id="documentoActual.Servicios_documentos_id"
            :nombre_doc="documentoActual.detalles.nombre"
            :servicio-id="detalle.servicio_id"
            :archivos_pre="getArchivosUsuario(documentoActual)"
            :index="indexActual"
            :maxFiles="10"
            @close-modal="cerrarModal"
            @archivo-subido="archivoSubido"
            @archivo-eliminado="actualizarListaDeArchivos"
          />
          <ModalInspectorFiles
            v-if="mostrarModalInspector"
            :visible="mostrarModalInspector"
            :nombre_doc="documentoInspectorActual?.detalles?.nombre || ''"
            :archivos="getArchivosInspector(documentoInspectorActual || {})"
            @close-modal="cerrarModalInspector"
          />
        </section>

        <!-- Seccion de notas -->
        <section
          class="nom-card ml-3 mt-3 mt-md-0 changes-history"
          style="min-width: 15%; max-width: 35%"
          v-if="notas"
        >
          <div class="d-flex justify-content-between">
            <h5>Historial de cambios</h5>
            <i class="fa fa-minus" v-on:click="notas = !notas"></i>
          </div>
          <hr />
          <div
            class="card-footer card-comments"
            style="overflow-y: auto; max-height: 80%"
          >
            <div
              v-for="(notas, index) in detalle?.Servicio.notas
                .slice()
                .reverse()"
              :key="index"
              class="card-comment"
            >
              <div
                class="comment-text"
                style="text-align: left; margin-left: 0 !important"
              >
                {{ notas.comentario }}
              </div>
              <span class="text-muted float-right">
                {{ new Date(notas.createdAt).toLocaleString("es-MX") }}
              </span>
            </div>
          </div>
        </section>
        </div>
      </div>
      <div v-if="loading" class="spinner-overlay">
        <div
          class="spinner-border text-primary"
          style="width: 3rem; height: 3rem"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div>
        <FlashMessage
          :style="{ position: 'fixed', zIndex: 9999, fontSize: '18px' }"
        ></FlashMessage>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from "../../services/axiosInstance";
import { Tooltip, Popover } from "bootstrap";
import { nextTick } from "vue";
import logoBaessh from "../../assets/logobaessh.svg";
import ModalFile from "./ModalFile.vue";
import ModalInspectorFiles from "./ModalInspectorFiles.vue";

export default {
  name: "ServicioDetalle",
  components: {
    ModalFile,
    ModalInspectorFiles,
  },
  data() {
    return {
      intervalId: null,
      faseVistaIndexLocal: null,
      notas: false,
      detalle: null,
      comentarioByDocumento: {},
      uploadProgress: {},
      downloadProgressByFile: {},
      downloadProgressTimers: {},
      loading: false,
      isSending: false,
      mostrarModal: false,
      mostrarModalInspector: false,
      logoLoaded: false,
      logoBaessh,
      documentoActual: null,
      documentoInspectorActual: null,
      indexActual: null,
      etapasTramite: [
        { id: "recoleccion", label: "Recolección de documentos", icon: "fas fa-folder-open" },
        { id: "revision", label: "Revisión de campo", icon: "fas fa-comments" },
        { id: "descarga", label: "Descarga de portafolio", icon: "fas fa-download" },
      ],
    };
  },
  computed: {
    cotizacionReferencia() {
      const nombre = this.detalle?.Servicio?.Cotizacione?.name;
      return (typeof nombre === "string" && nombre.trim())
        ? nombre.trim()
        : "";
    },
    clienteServicioReferencia() {
      const nombre = this.detalle?.Servicio?.cliente_nombre;
      return (typeof nombre === "string" && nombre.trim())
        ? nombre.trim()
        : "";
    },
    clienteLogoUrl() {
      const servicio = this.detalle?.Servicio || {};
      return servicio.cliente_logo_url;
    },
    clienteIniciales() {
      const nombre = String(this.detalle?.Servicio?.cliente_nombre || "").trim();
      if (!nombre) return "CL";
      const partes = nombre.split(/\s+/).filter(Boolean);
      if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
      return `${partes[0][0] || ""}${partes[1][0] || ""}`.toUpperCase();
    },
    fechaCreacion() {
      if (!this.detalle?.createdAt) return "-";
      return new Date(this.detalle.createdAt).toLocaleDateString("es-MX");
    },
    etapaActualIndex() {
      const raw = Number(this.detalle?.Servicio?.estatus);
      if ([0, 1, 2].includes(raw)) return raw;
      return 0;
    },
    faseVistaIndex() {
      if (
        [0, 1, 2].includes(this.faseVistaIndexLocal) &&
        this.canSelectFase(this.faseVistaIndexLocal)
      ) {
        return this.faseVistaIndexLocal;
      }
      return this.etapaActualIndex;
    },
    documentosVisibles() {
      const docs = this.detalle?.Servicio?.servicios_documentos || [];
      if (this.faseVistaIndex === 0) {
        return docs.filter((doc) => !this.esDocumentoObservacion(doc));
      }
      if (this.faseVistaIndex === 1) {
        return docs.filter((doc) => this.esDocumentoObservacion(doc));
      }
      return docs;
    },
    entregasVisibles() {
      return this.detalle?.Servicio?.entregas || [];
    },
  },
  watch: {
    clienteLogoUrl() {
      this.logoLoaded = false;
    },
  },
  methods: {
    goToHome() {
      this.$router.push("/home");
    },
    goToServicios() {
      const backFromQuery = this.$route.query?.back;
      const backFromStorage = localStorage.getItem("pamDetalleBackLink");
      const fallback = "/home";
      this.$router.push(backFromQuery || backFromStorage || fallback);
    },
    canSelectFase(index) {
      // Fase 1 siempre se puede consultar.
      if (index === 0) return true;
      // Fase 2 se puede consultar cuando el servicio ya está en estatus 1 o 2.
      if (index === 1) return this.etapaActualIndex >= 1;
      // Fase 3 solo es navegable cuando estatus real es 2.
      if (index === 2) return this.etapaActualIndex === 2;
      return [0, 1, 2].includes(index);
    },
    setFaseVista(index) {
      if (this.canSelectFase(index)) {
        this.faseVistaIndexLocal = index;
      }
    },
    esDocumentoObservacion(doc) {
      const clasificacion = String(doc?.detalles?.clasificacion || "")
        .toLowerCase()
        .trim();
      return clasificacion.includes("observ");
    },
    getDocStatusCode(doc) {
      const status = Number(doc?.estatus);
      if ([0, 1, 2, 3].includes(status)) return status;
      return 0;
    },
    getDocStatusText(doc) {
      const status = this.getDocStatusCode(doc);
      if (status === 1) return "En revisión";
      if (status === 2) return "Aceptado";
      if (status === 3) return "Rechazado";
      return "Pendiente";
    },
    getDocStatusBadgeClass(doc) {
      const status = this.getDocStatusCode(doc);
      if (status === 1) return "badge-info";
      if (status === 2) return "badge-success";
      if (status === 3) return "badge-danger";
      return "badge-secondary";
    },
    getDocStatusTextClass(doc) {
      const status = this.getDocStatusCode(doc);
      if (status === 1) return "text-info font-weight-bold";
      if (status === 2) return "text-success font-weight-bold";
      if (status === 3) return "text-danger font-weight-bold";
      return "text-secondary font-weight-bold";
    },
    abrirModal(doc, index) {
      this.documentoActual = doc;
      this.indexActual = index;
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
    },
    abrirModalInspector(doc) {
      this.documentoInspectorActual = doc;
      this.mostrarModalInspector = true;
    },
    cerrarModalInspector() {
      this.mostrarModalInspector = false;
      this.documentoInspectorActual = null;
    },
    esArchivoInspector(archivo) {
      return String(archivo?.subido_por || "").toLowerCase() === "inspector";
    },
    getArchivosInspector(doc) {
      const archivos = doc?.documentos_archivos || [];
      return archivos.filter((archivo) => this.esArchivoInspector(archivo));
    },
    getArchivosUsuario(doc) {
      const archivos = doc?.documentos_archivos || [];
      return archivos.filter((archivo) => !this.esArchivoInspector(archivo));
    },
    hasInspectorFiles(doc) {
      return this.getArchivosInspector(doc).length > 0;
    },
    hasPendingObservaciones(doc) {
      return doc?.visto == 1 || doc?.visto == 3;
    },
    onLogoLoad() {
      this.logoLoaded = true;
    },
    onLogoError() {
      this.logoLoaded = true;
    },
    async archivoSubido({ index, documentoId, nota, archivos }) {
      const docs = this.detalle?.Servicio?.servicios_documentos || [];
      let realIndex = -1;
      if (documentoId != null) {
        realIndex = docs.findIndex(
          (d) => d.Servicios_documentos_id === documentoId
        );
      }
      if (realIndex === -1) realIndex = index;
      if (realIndex === -1) return;

      // Actualiza el estatus a 1
      docs[realIndex].estatus = 1;

      // Asocia la nueva nota
      if (!Array.isArray(this.detalle?.Servicio?.notas)) {
        this.$set(this.detalle.Servicio, "notas", []);
      }
      this.detalle.Servicio.notas.push(nota);

      //ACTUALIZAR ARCHIVOS
      const doc = docs[realIndex];
      if (doc) {
        const existentes = doc.documentos_archivos || [];

        const fusionados = [
          ...existentes,
          ...archivos.filter(
            (nuevo) =>
              !existentes.some((existente) => existente.id === nuevo.id)
          ),
        ];

        doc.documentos_archivos = fusionados;

        if (
          this.documentoActual?.Servicios_documentos_id ===
          doc.Servicios_documentos_id
        ) {
          this.documentoActual.documentos_archivos = fusionados;
        }
      }
    },
    triggerFileInput(index) {
      document.getElementById("fileInput-" + index).click();
    },
    actualizarListaDeArchivos(idArchivoEliminado) {
      this.documentoActual.documentos_archivos =
        this.documentoActual.documentos_archivos.filter(
          (a) => a.id !== idArchivoEliminado
        );
      if (this.documentoActual.documentos_archivos.length === 0) {
        this.documentoActual.estatus = 0;
      }
    },
    setDownloadState(fileKey, nextState) {
      if (this.$set) {
        this.$set(this.downloadProgressByFile, fileKey, nextState);
        return;
      }
      this.downloadProgressByFile[fileKey] = nextState;
    },
    clearDownloadState(fileKey) {
      this.stopEstimatedDownloadProgress(fileKey);
      if (this.$delete) {
        this.$delete(this.downloadProgressByFile, fileKey);
        return;
      }
      delete this.downloadProgressByFile[fileKey];
    },
    isFileDownloading(fileKey) {
      return Boolean(this.downloadProgressByFile[fileKey]?.isDownloading);
    },
    getFileDownloadProgress(fileKey) {
      return Number(this.downloadProgressByFile[fileKey]?.progress || 0);
    },
    stopEstimatedDownloadProgress(fileKey) {
      const timer = this.downloadProgressTimers[fileKey];
      if (timer) {
        clearInterval(timer);
        if (this.$delete) {
          this.$delete(this.downloadProgressTimers, fileKey);
          return;
        }
        delete this.downloadProgressTimers[fileKey];
      }
    },
    stopAllEstimatedDownloadProgress() {
      Object.keys(this.downloadProgressTimers).forEach((key) => {
        this.stopEstimatedDownloadProgress(key);
      });
    },
    descargarArchivo(id, fileKey) {
      if (!id) {
        this.flashMessage.warning({
          message: "Este archivo aún no ha sido cargado por el inspector",
        });
        return;
      }

      const safeFileKey = String(fileKey || id);
      this.setDownloadState(safeFileKey, { isDownloading: true, progress: 0 });
      axiosInstance
        .post(
          "/pam/descargarArchivo",
          { file: id },
          {
            responseType: "blob",
            onDownloadProgress: (progressEvent) => {
              const loaded = Number(progressEvent.loaded || 0);
              const total = progressEvent.total;
              if (total && Number(total) > 0) {
                this.stopEstimatedDownloadProgress(safeFileKey);
                const progress = Math.min(99, Math.round((loaded * 100) / total));
                this.setDownloadState(safeFileKey, {
                  isDownloading: true,
                  progress,
                  estimated: false,
                });
                return;
              }
            },
          }
        )
        .then((response) => {
          if (!response?.data) return;

          const contentType =
            response.headers?.["content-type"] || "application/octet-stream";
          const disposition = response.headers?.["content-disposition"] || "";
          const filenameMatch =
            /filename\*?=(?:UTF-8''|")?([^";]+)"?/i.exec(disposition);
          const rawFilename = filenameMatch?.[1] || "archivo";
          const filename = decodeURIComponent(rawFilename);

          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(() => window.URL.revokeObjectURL(url), 1000);
          this.setDownloadState(safeFileKey, { isDownloading: true, progress: 100 });
        })
        .catch((error) => {
          console.error(error);
          this.flashMessage.error({
            message: "[ERROR]: No se encontró ningún documento",
          });
        })
        .finally(() => {
          this.stopEstimatedDownloadProgress(safeFileKey);
          setTimeout(() => {
            this.clearDownloadState(safeFileKey);
          }, 600);
        });
    },
    vistaPrevia(id) {
      if (id) {
        axiosInstance
          .post("/pam/vistaPreviaArchivo", { file: id })
          .then((response) => {
            if (response.data) {
              window.open(response.data, "_blank");
            }
          })
          .catch((error) => {
            console.error(error);
            this.flashMessage.error({
              message: "[ERROR]: No se encontró ningún documento",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.flashMessage.warning({
          message: "Este archivo aún no ha sido cargado por el inspector",
        });
      }
    },

    async getDetalle(id) {
      this.loading = true;
      try {
        const response = await axiosInstance.get("/pam/detalle", {
          params: {
            id: id,
          },
        });
        if (!response.data) {
          this.$router.push("/home");
        }
        this.detalle = response.data;
      } catch (error) {
        console.error("Error al obtener datos del usuario:", error);
      } finally {
        this.loading = false;
      }
    },
    async guardarComentario(id) {
      const comentarioActual = String(
        this.comentarioByDocumento[id] || ""
      ).trim();
      if (!comentarioActual || this.isSending) return;

      this.isSending = true;

      try {
        const response = await axiosInstance.post("/pam/guardarComentario", {
          id: id,
          comentario: comentarioActual,
        });
        const docs = this.detalle?.Servicio?.servicios_documentos || [];
        const realIndex = docs.findIndex(
          (doc) => doc.Servicios_documentos_id === id
        );
        if (realIndex === -1) return;
        if (!Array.isArray(docs[realIndex].Comentarios)) {
          this.$set(docs[realIndex], "Comentarios", []);
        }
        docs[realIndex].Comentarios.push(response.data);
        this.scrollToBottom(id);
        this.$set(this.comentarioByDocumento, id, "");
      } catch (error) {
        console.error(
          "Error al guardar el comentario. Intente de nuevo o comuniquese con nosotros.",
          error
        );
      } finally {
        this.isSending = false;
      }
    },
    scrollToBottom(documentoId) {
      const refName = `comentariosContainer-${documentoId}`;
      const refValue = this.$refs[refName];
      const rawContainer = Array.isArray(refValue) ? refValue[0] : refValue;
      const container = rawContainer?.$el || rawContainer;
      if (container) {
        const keepBottom = () => {
          container.scrollTop = container.scrollHeight;
        };
        nextTick(() => {
          keepBottom();
          if (typeof window !== "undefined" && window.requestAnimationFrame) {
            window.requestAnimationFrame(keepBottom);
          }
          setTimeout(keepBottom, 180);
        });
      }
    },
    scrollToBottomOnModalOpen(documentoId) {
      nextTick(() => {
        this.scrollToBottom(documentoId);
        setTimeout(() => this.scrollToBottom(documentoId), 260);
      });
    },
    irdatos_generales(doc) {
      const id = this.detalle.Servicio.cliente_id;
      const ser_doc_id = doc.Servicios_documentos_id;
      const giro = this.detalle.giro;

      this.$router.push({
        path: `/datos-generales/${id}`,
        query: { giro, ser_doc_id },
      });
    },
    async vistoChat(item) {
      let visto = item.visto;
      if (visto == 1 || visto == 3) {
        try {
          const response = await axiosInstance.post("/pam/vistoChat", {
            id: item.Servicios_documentos_id,
          });
          this.$set(item, "visto", response.data);
        } catch (error) {
          this.flashMessage.error({
            message:
              "[ERROR]: No se pudo establecer la conexión con el servidor. Revisa tu conexión a internet.",
          });
        }
      }
      this.scrollToBottomOnModalOpen(item.Servicios_documentos_id);
    },
    async descargarFormato(formato, nombre) {
      try {
        const response = await axiosInstance.post(
          "/pam/formatosPC",
          { id: this.detalle.Servicio.cliente_id, formato: formato },
          { responseType: "blob" }
        );

        // Crear un enlace de descarga
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${nombre}.docx`); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        this.flashMessage.error({
          message:
            "[ERROR]: Es necesario actualizar los datos generales para continuar.",
        });
      }
    },
    iniciarActualizacion() {
      this.getDetalle(this.$route.params.id);

      // Establecer intervalo para actualizar cada 20 minutos (1200000 ms)
      this.intervalId = setInterval(() => {
        this.getDetalle(this.$route.params.id);
      }, 1200000);
    },
    detenerActualizacion() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    formatDate(coment) {
      if (coment.user == 1) {
       return new Date(coment.createdAt).toLocaleString("es-MX", {
          hour12: false
        }); 
      }
      return coment.createdAt.replace("T", " ").replace(".000Z", "")
    }
  },
  mounted() {
    const backFromQuery = this.$route.query?.back;
    if (backFromQuery) {
      localStorage.setItem("pamDetalleBackLink", backFromQuery);
    }
    this.iniciarActualizacion();

    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });

    new Popover(document.body, {
      selector: "[data-bs-toggle='popover']",
      trigger: "focus",
    });
  },
  beforeDestroy() {
    this.stopAllEstimatedDownloadProgress();
    this.detenerActualizacion(); // Detener el intervalo si el componente se destruye
  },
};
</script>

<style>
.detalle-main-wrap {
  width: 100%;
}

.detalle-wide-container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}

.detalle-head {
  text-align: left;
  margin-bottom: 20px;
}

.detalle-head-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.detalle-ref-line {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  letter-spacing: 0.05em;
  margin-bottom: 1rem;
}

.detalle-ref-muted {
  color: #92a2b8;
  font-weight: 600;
}

.detalle-ref-link {
  color: #92a2b8;
  font-weight: 600;
  cursor: pointer;
}

.detalle-ref-link:hover {
  color: #0f2f5f;
}

.detalle-ref-sep {
  color: #9cafc7;
  font-weight: 700;
  transform: translateY(-1px);
}

.detalle-ref-strong {
  color: #0f2f5f;
  font-weight: 800;
}

.detalle-title {
  margin: 0;
  font-size: 42px;
  line-height: 1.1;
  color: #101e3d;
  font-weight: 800;
}

.detalle-profile-chip {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  padding: 3px;
  background: linear-gradient(140deg, #8fb8ea 0%, #1c5ca8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.detalle-profile-avatar {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #ffffff;
  background: #ffffff;
  color: #21538c;
  font-size: 1.2rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.detalle-profile-image {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.32s ease;
}

.detalle-profile-image--cliente {
  object-fit: contain;
  padding: 8px;
  box-sizing: border-box;
  background: #ffffff;
}

.detalle-profile-image--visible {
  opacity: 1;
}

.detalle-profile-placeholder {
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: 50%;
  background: linear-gradient(120deg, #e1eafa 20%, #f6f9ff 40%, #d6e3f8 60%);
  background-size: 200% 100%;
  animation: logoShimmer 1.1s linear infinite;
}

@keyframes logoShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.tramite-steps {
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 26px;
  justify-content: center;
  position: relative;
}

.tramite-steps::before {
  content: "";
  position: absolute;
  top: 44px;
  left: 8%;
  right: 8%;
  height: 2px;
  background: #d9e4f3;
  z-index: 0;
}

.tramite-progress-wrap {
  margin-top: 14px;
  text-align: center;
}

.tramite-step {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 310px;
  max-width: 100%;
  padding: 10px 12px;
  border-radius: 14px;
  background: #f3f7fd;
  border: 1px solid #d8e2f0;
  color: #5a6f88;
  font-size: 12px;
  font-weight: 600;
  position: relative;
  z-index: 1;
  cursor: pointer;
}

.tramite-step--locked {
  opacity: 0.90;
  cursor: not-allowed;
}

.tramite-step-phase {
  align-self: flex-start;
  margin-bottom: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #dde7f5;
  color: #456186;
}

.tramite-step-top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tramite-step-badge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #d5deec;
  color: #2c4362;
  font-size: 11px;
  font-weight: 800;
}

.tramite-step-icon {
  font-size: 13px;
}

.tramite-step-state {
  margin-top: 6px;
  align-self: flex-start;
  font-size: 0.73rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e3ebf7;
  color: #4f6787;
}

.tramite-step--done {
  background: #eaf4ff;
  border-color: #bbd7f8;
  color: #1a4b86;
}

.tramite-step--done .tramite-step-badge {
  background: #0f4c96;
  color: #ffffff;
}

.tramite-step--actual:not(.tramite-step--active) {
  border-color: #0f4c96;
  box-shadow: inset 0 0 0 1px rgba(15, 76, 150, 0.25);
}

.tramite-step--actual:not(.tramite-step--active) .tramite-step-badge {
  background: #0f4c96;
  color: #ffffff;
}

.tramite-step--active {
  background: #0f4c96;
  border-color: #0f4c96;
  color: #ffffff;
  transform: scale(1.1);
  box-shadow: 0 12px 24px rgba(15, 76, 150, 0.28);
}

.tramite-step--active .tramite-step-badge {
  background: #ffffff;
  color: #0f4c96;
}

.tramite-step--active .tramite-step-state {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.tramite-step--active .tramite-step-phase {
  background: rgba(255, 255, 255, 0.22);
  color: #ffffff;
}

.tramite-step--done .tramite-step-state {
  background: #d5e8ff;
  color: #1f4f86;
}

.tramite-step--done .tramite-step-phase {
  background: #cae1ff;
  color: #1f4f86;
}

.body-card {
  display: flex;
}
.card {
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2);
  margin-bottom: 1rem;
}
.service-summary-card {
  border: 1px solid #e6edf6;
  box-shadow: 0 8px 24px rgba(15, 47, 95, 0.08);
}

.service-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 0.8rem;
  font-weight: 700;
}

.service-pill--folio {
  background: #e8f0ff;
  color: #164684;
  border: 1px solid #c7daf7;
}

.service-pill--date {
  border: 1px solid #dce5f3;
  background: #f7faff;
  color: #3c5778;
  font-weight: 600;
}

.btn-notas {
  background-color: #2b416d;
  color: white;
  border-radius: 5px;
}
.datos-card {
  width: 100%;
  overflow-y: auto;
}
.nom-card {
  padding: 10px 20px 10px 20px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.fase3-hero {
  margin: 6px 0 16px;
  padding: 16px 18px;
  border: 1px solid #cfe0fa;
  border-radius: 12px;
  background: linear-gradient(135deg, #f7fbff 0%, #eef5ff 100%);
  text-align: center;
}

.fase3-hero__eyebrow {
  margin: 0 0 4px;
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: #5b77a0;
  text-transform: uppercase;
}

.fase3-hero__title {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 800;
  color: #103766;
}

.fase3-hero__sub {
  margin: 6px 0 0;
  color: #5e7598;
  font-size: 0.92rem;
}

.fase3-entrega-card {
  border: 1px solid #dfe7f2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(18, 59, 108, 0.06);
  padding: 14px;
  width: 100%;
}

.fase3-entrega-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.fase3-entrega-title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.fase3-entrega-icon {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: #eaf2ff;
  color: #184f96;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.fase3-entrega-title {
  margin: 0;
  font-weight: 800;
  color: #13386a;
}

.fase3-entrega-badge {
  border: 1px solid #c8daf5;
  background: #f0f6ff;
  color: #1f4f86;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 0.78rem;
  font-weight: 700;
}

.fase3-files-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  border-top: 1px solid #e7edf6;
}

.fase3-file-item {
  border: 0;
  border-bottom: 1px solid #edf2f8;
  border-radius: 0;
  padding: 11px 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  background: transparent;
}

.fase3-file-item:last-child {
  border-bottom: 0;
}

.fase3-file-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.fase3-file-icon {
  width: 26px;
  height: 26px;
  border-radius: 4px;
  background: #e9f1ff;
  color: #24589b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.fase3-file-name {
  color: #304965;
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fase3-file-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.fase3-file-btn {
  border-radius: 999px;
  border: 1px solid #1b5fad;
  background: linear-gradient(135deg, #1b5fad 0%, #1a75d2 100%);
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 700;
  padding: 6px 14px;
  box-shadow: 0 6px 14px rgba(27, 95, 173, 0.28);
  color: white !important;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease,
    border-color 0.15s ease;
}

.fase3-file-btn:hover {
  background: linear-gradient(135deg, #15508f 0%, #185fb0 100%);
  border-color: #144a87;
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(27, 95, 173, 0.32);
}

.fase3-file-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 10px rgba(27, 95, 173, 0.24);
}

.fase3-file-btn:focus-visible {
  outline: 2px solid #9cc7ff;
  outline-offset: 2px;
}

.fase3-file-btn[disabled] {
  opacity: 0.8;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 4px 10px rgba(27, 95, 173, 0.18);
}

.fase3-empty {
  border: 0;
  border-radius: 6px;
  padding: 10px 2px;
  font-size: 0.88rem;
  background: transparent;
  text-align: center;
}

.revision-empty-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #d6e3f4;
  border-radius: 10px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
  text-align: left;
}

.revision-empty-notice__icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #e4eeff;
  color: #1a569f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.revision-empty-notice__title {
  margin: 0 0 2px;
  font-size: 0.98rem;
  font-weight: 800;
  color: #173f72;
}

.revision-empty-notice__text {
  margin: 0;
  color: #5d7392;
  font-size: 0.88rem;
}
.observacion-phase-banner {
  margin-top: 12px;
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #f2d9d9;
  background: #fff8f8;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #b42318;
  font-weight: 600;
}

.card-document {
  padding: 0.8rem;
  border-radius: 8px;
  margin-bottom: 0.7rem;
  border-width: 3px; /* Borde medianamente grueso */
  border-style: solid;
  transition: all 0.3s ease-in-out;
  height: 100%;
}

@media (max-width: 576px) {
  .detalle-head-top {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    column-gap: 10px;
  }

  .detalle-profile-chip {
    width: 82px;
    height: 82px;
    margin-left: 0;
  }

  .detalle-ref-line {
    font-size: 12px;
    max-width: 100%;
    overflow: hidden;
  }

  .detalle-ref-link,
  .detalle-ref-strong {
    display: inline-block;
    max-width: 40vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .detalle-title {
    font-size: 32px;
  }

  .tramite-step {
    min-width: 100%;
  }

  .tramite-steps::before {
    display: none;
  }

  .tramite-step--active {
    transform: none;
  }

  .fase3-file-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .fase3-file-btn {
    width: 100%;
  }

  .fase3-file-actions {
    width: 100%;
    justify-content: flex-start;
  }
}

.card-document-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-document .card-text {
  font-size: 0.9rem;
  color: #555;
}

.card-document-desc {
  margin: 6px 0 8px;
  font-size: 0.82rem;
  color: #5f6875;
  line-height: 1.35;
}

.btn-doc {
  padding: 0.2rem;
  font-size: 0.875rem;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
  width: 8rem;
  margin: 0.2rem;
}
.btn-inspector-attn {
  background: linear-gradient(135deg, #ff8a00, #ff4d4f);
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.1px;
  box-shadow: 0 4px 10px rgba(255, 77, 79, 0.25);
  border: none;
}

.btn-observaciones-attn {
  background: #ffd85a !important;
  color: #1f2937 !important;
  font-weight: 700;
  border: 1px solid #d8aa2c;
  box-shadow: none;
}

.btn-observaciones {
  background: #ffe27f !important;
  color: #1f2937 !important;
  font-weight: 500;
  border: 1px solid #dfbd55;
}

.notas-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 999px;
  background: #b91c1c;
  color: #ffffff;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

/* Colores fijos */
.card-document.pendiente {
  border-color: #a0a4a7; /* Rojo */
}

.card-document.en-revision {
  border-color: #009dff; /* Gris */
}

.card-document.aceptado {
  border-color: #28a745; /* Verde */
}

.card-document.rechazado {
  border-color: #dc3545; /* Verde */
}

.content-buttons {
  display: flex;
  flex-direction: column;
}
.notas-indicator {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 18px;
  height: 18px;
  background: #b91c1c;
  color: #ffffff;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 5px rgba(185, 28, 28, 0.25);
}

.comment-author-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.comment-author-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.comment-author-icon--empresa {
  background: #eaf7ef;
  color: #1b6a3a;
}

.chat-thread {
  border: 1px solid #dee2e6;
  overflow-x: hidden;
}

.chat-bubble {
  max-width: 78%;
  min-width: 0;
  padding: 0.6rem 0.8rem;
  border-radius: 0.85rem;
  border: 1px solid #d9e4f3;
}

.comment-body-text {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.chat-bubble--baessh {
  background: #ffffff;
  border-top-left-radius: 0.35rem;
}

.chat-bubble--cliente {
  background: #f1f6fc;
  border-color: #c6d7ea;
  border-top-right-radius: 0.35rem;
}

.chat-time {
  white-space: normal;
  line-height: 1.2;
}

@keyframes inspector-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 767px) {
  .body-card .d-flex {
    flex-direction: column;
  }

  .nom-card.ml-3 {
    margin-left: 0 !important;
    margin-top: 1rem;
  }
  .changes-history {
    max-height: 20rem;
    max-width: 100% !important;
  }
  .fa-minus {
    display: none;
  }
}

/* En pantallas grandes, los elementos estarán uno al lado del otro */
@media (min-width: 768px) {
  .body-card .d-flex {
    flex-direction: row;
  }

  .nom-card.ml-3 {
    margin-left: 1rem;
  }
}

@media (max-width: 1200px) {
  .card-document-body {
    flex-direction: column;
  }
  .card-document-body > div {
    width: 100%;
    max-width: none !important;
  }
  .content-buttons {
    flex-direction: row;
  }

  @media (max-width: 1100px) {
    .content-buttons {
      flex-direction: column;
    }
    .content-buttons > button {
      width: 100%;
    }
  }
}

.comentario-arrive-enter-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}

.comentario-arrive-enter {
  opacity: 0;
  transform: translateY(10px);
}
</style>
